//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

// prettier-ignore
const RouteConstants = {
  HOME                          : '/',
  LOGIN                         : '/login',
  AWS_MARKETPLACE_THANK_YOU     : '/aws-marketplace/thank-you',
  FORGOT_PASSWORD               : '/authentication/forgotpassword',
  FORGOT_PASSWORD_SENT          : '/authentication/forgotpasswordsent',
  PASSWORD_RESET                : '/authentication/resetpassword',
  PASSWORD_RESET_SUCCESS        : '/authentication/passwordresetsuccess',
  DATA_STUDIO_ROOT              : '/data-studio',
  DATA_STUDIO_ENTITY            : '/data-studio/entity/{entityId}',
  DATA_STUDIO_RECORD            : '/data-studio/entity/{entityId}/record/{recordId}',
  DATA_STUDIO_RECORD_FIELDS     : '/data-studio/entity/{entityId}/record/{recordId}/fields',
  DATA_STUDIO_RECORD_TRANSACTIONS : '/data-studio/entity/{entityId}/record/{recordId}/lineage',
  DATA_STUDIO_REFDATA_ROOT      : '/data-studio/reference-data',
  DATA_STUDIO_REFDATA           : '/data-studio/reference-data/{refDataId}',
  DATA_QUALITY_STUDIO_ROOT      : '/data-quality-studio',
  DATA_QUALITY_STUDIO_DASHBOARD : '/data-quality-studio/{dashboardId}',
  SYNC_STUDIO                   : '/sync-studio',
  ENTITIES                      : '/sync-studio/{tabId}',
  ENTITY                        : '/sync-studio/{tabId}/{entityId}',
  QUICK_START                   : '/sync-studio/{tabId}/quick-start',
  QUICK_START_AUTHOR            : '/sync-studio/{tabId}/quick-start/author',
  QUICK_START_INSTALL           : '/sync-studio/{tabId}/quick-start/{quickStartId}/install',
  ENTITY_PIPELINE               : '/sync-studio/entity/{entityId}/pipeline',
  ENTITY_DETAIL                 : '/sync-studio/entity/{entityId}/{tabId}',
  ENTITY_VERSIONS               : '/sync-studio/entity/{entityId}/versions',
  ENTITY_LOGS                   : '/sync-studio/entity/{entityId}/pipeline-logs/{graphVersion}',
  DATA_QUALITY                  : '/sync-studio/entity/{entityId}/data-quality/{graphVersion}',
  DATA_QUALITY_CATEGORIES       : '/sync-studio/entity/{entityId}/data-quality/{graphVersion}/manage-categories',
  DATA_QUALITY_RULES            : '/sync-studio/entity/{entityId}/data-quality/{graphVersion}/manage-rules',
  DATA_QUALITY_RULE             : '/sync-studio/entity/{entityId}/data-quality/{graphVersion}/manage-rules/{ruleId}',
  ENTITY_VERSIONS_COMPARE       : '/sync-studio/entity/{entityId}/versions/{versionOneId}/compare/{versionTwoId}',
  ENTITY_VERSION_DETAIL         : '/sync-studio/entity/{entityId}/versions/{versionOneId}',
  ENTITY_PIPELINE_GRAPH_VERSION : '/sync-studio/entity/{entityId}/pipeline/{graphVersion}',
  ENTITY_PIPELINE_VALIDATION    : '/sync-studio/entity/{entityId}/pipeline/{graphVersion}/validation',
  ENTITY_PIPELINE_ERROR         : '/sync-studio/entity/{entityId}/pipeline/{graphVersion}/pipeline-error',
  ENTITY_DOCUMENTATION_VERSION  : '/sync-studio/entity/{entityId}/documentation/{graphVersion}',
  FIELD_PIPELINE                : '/sync-studio/entity/{entityId}/field/{fieldId}/pipeline',
  FIELD_PIPELINE_GRAPH_VERSION  : '/sync-studio/entity/{entityId}/field/{fieldId}/pipeline/{graphVersion}',
  FIELD_PIPELINE_VALIDATION     : '/sync-studio/entity/{entityId}/field/{fieldId}/pipeline/{graphVersion}/validation',
  FIELD_PIPELINE_ERROR          : '/sync-studio/entity/{entityId}/field/{fieldId}/pipeline/{graphVersion}/pipeline-error',
  SCHEMA_STUDIO_ROOT            : '/schema-studio',
  SCHEMA_STUDIO_SYNAPSE         : '/schema-studio/synapse/{connectorId}',
  SCHEMA_STUDIO_SYNAPSE_ENTITY  : '/schema-studio/synapse/{connectorId}/entity/{entityApiName}/{version}',
  SSO_ASSERTION_URL             : '/sso/{organizationId}/assertion',
  SSO_ENTITY_URL                : '/sso/{organizationId}',
  SUBSCRIPTION                  : '/subscription',
  USER                          : '/user',
  INSTANCE                      : '/instance',
  CREDENTIAL                    : '/credential',
  REFERENCEDATA                 : '/reference-data',
  TRANSACTIONS                  : '/transactions',
  LOGS                          : '/logs',
  LOGS_TYPE                     : '/logs/{type}',
  LOGS_TRANSACTIONS             : '/logs/operations',
  LOGS_SYNC_ERRORS              : '/logs/sync-errors',
  SETTINGS                      : '/settings',
  SETTINGS_TYPE                 : '/settings/{type}',
  SETTINGS_ACCESS_CONTROL       : '/settings/access-control',
  SETTINGS_RBAC                 : '/settings/access-control/role-based',
  SETTINGS_BRANDING             : '/settings/branding',
  SETTINGS_DATA_FIX             : '/settings/data-fix',
  NOTIFICATION                  : '/notifications',
  ERROR_UI                      : '/errors/error-ui',
  ERROR_404                     : '/errors/error-404',
  ERROR_504                     : '/errors/error-504',
  IMPORTED_FILES                : '/imported-files',
  IMPORTED_FILES_FOLDER         : '/imported-files/folder/{folderId}',
  IMPORTED_FILES_FILE           : '/imported-files/folder/{folderId}/file/{fileId}',
  BUSINESS_STUDIO               : '/business-studio',
  BUSINESS_STUDIO_ENTITY        : '/business-studio/entity/{entityId}',
  BUSINESS_STUDIO_MERGE_REVIEW  : '/business-studio/entity/{entityId}/merge-review/{mergeRecordId}',
  BUSINESS_DASHBOARD            : '/business-studio/entity/{entityId}/record/{recordId}/dashboard',
  BUSINESS_DASHBOARD_WITH_LAYOUT: '/business-studio/entity/{entityId}/record/{recordId}/dashboard/{layoutId}',
  BUSINESS_DASHBOARD_EDIT       : '/business-studio/entity/{entityId}/record/{recordId}/dashboard/{layoutId}/edit',
  BUSINESS_DASHBOARD_SCHEMA     : '/business-studio/entity/{entityId}/record/{recordId}/dashboard/{layoutId}/schema',
  INSIGHTS_STUDIO               : '/insights-studio',
  INSIGHTS_STUDIO_DASHBOARD     : '/insights-studio/{dashboardId}',
  INSIGHTS_STUDIO_DASHBOARD_DRAFT: '/insights-studio/{dashboardId}/draft',
  INSIGHTS_STUDIO_DASHBOARD_SHARE_WITH: '/insights-studio/{dashboardId}/published/share-with',
  INSIGHTS_STUDIO_DASHBOARD_SHARING_DETAILS: '/insights-studio/{dashboardId}/published/sharing-details',
  INSIGHTS_STUDIO_SHARED_DASHBOARD: '/insightssharing/user/{email}/dashboard/{dashboardId}',
  INSIGHTS_STUDIO_SHARED_DASHBOARD_ENTER_PASSWORD: '/insightssharing/enter-password/user/{email}/dashboard/{dashboardId}',
  INSIGHTS_STUDIO_SHARED_DASHBOARD_EXPIRED: '/insightssharing/expired-dashboard/user/{email}/dashboard/{dashboardId}',
  INSIGHTS_STUDIO_DATASET       : '/insights-studio/{dashboardId}/draft/dataset/{datasetId}',
  INSIGHTS_STUDIO_DATASET_COPY  : '/insights-studio/{dashboardId}/draft/dataset/{datasetId}/copy',
  INSIGHTS_STUDIO_DATASET_PREVIEW: '/insights-studio/{dashboardId}/draft/dataset/{datasetId}/preview',
  INSIGHTS_STUDIO_AIASSISTED    : '/insights-studio/{dashboardId}/draft/aiassisted',
  INSIGHTS_STUDIO_DATA_CARD     : '/insights-studio/{dashboardId}/draft/datacard/{dataCardId}',
  INSIGHTS_STUDIO_DATA_CARD_COPY: '/insights-studio/{dashboardId}/draft/datacard/{dataCardId}/copy',
  INSIGHTS_STUDIO_DATA_CARD_COPY_ADD: '/insights-studio/{dashboardId}/draft/datacard/{dataCardId}/copy-add',
  INSIGHTS_STUDIO_TS_TAB: "/insights-studio/ts/{tab}",
  INSIGHTS_STUDIO_TS_DASHBOARDS     : '/insights-studio/ts/dashboards',
  INSIGHTS_STUDIO_TS_DASHBOARDS_ID     : '/insights-studio/ts/dashboards/{dashboardId}',
  INSIGHTS_STUDIO_TS_DASHBOARD     : '/insights-studio/ts/dashboard/{dashboardId}',
  INSIGHTS_STUDIO_TS_DATASETS   : '/insights-studio/ts/datasets',
  INSIGHTS_STUDIO_TS_DATASET   : '/insights-studio/ts/datasets/{datasetId}',
  INSIGHTS_STUDIO_TS_DATASET_COPY  : '/insights-studio/ts/datasets/{datasetId}/copy',
  INSIGHTS_STUDIO_TS_DATASET_PREVIEW: '/insights-studio/ts/datasets/{datasetId}/preview',
  INSIGHTS_STUDIO_TS_SEARCH     : '/insights-studio/ts/search',
  INSIGHTS_STUDIO_TS_DATACARDS     : '/insights-studio/ts/datacards',
  INSIGHTS_STUDIO_TS_DATACARDS_ID     : '/insights-studio/ts/datacards/{datacardId}',
  INSIGHTS_NEXTGEN              : '/insights-nextgen',
  INSIGHTS_NEXTGEN_DASHBOARD    : '/insights-nextgen/{dashboardId}',
  INSIGHTS_NEXTGEN_CARD_NEW     : '/insights-nextgen/{dashboardId}/cards/new',
  INSIGHTS_NEXTGEN_CARD         : '/insights-nextgen/{dashboardId}/cards/{cardId}',
  PROFILE                       : '/profile',
  PROFILE_TYPE                  : '/profile/{type}',
  SETTINGS_AI                   : '/settings/ai',
  SETTINGS_NOTIFICATIONS        : '/settings/notifications',
  SETTINGS_NOTIFICATIONS_TYPE   : '/settings/notifications/{type}',
  SETTINGS_NOTIFICATIONS_TYPE_ADD   : '/settings/notifications/{type}/add',
  SETTINGS_NOTIFICATIONS_TYPE_EDIT  : '/settings/notifications/{type}/{id}/edit',
  SYNAPSES                          : '/synapses',
  SYNAPSES_CONNECTIONS              : '/synapses/connections',
  SYNAPSES_CUSTOM                   : '/synapses/custom-synapses',
  SYNAPSES_CUSTOM_ITEM               : '/synapses/custom-synapses/{synapseType}/{synapseId}',
  SYNAPSES_CUSTOM_ENTITIES: '/synapses/custom-synapses/http/{synapseId}/entities/{version}',
  SYNAPSES_CUSTOM_ENTITY: '/synapses/custom-synapses/http/{synapseId}/entities/{version}/{entityId}',
  DEVELOPER_STUDIO                         : '/developer-studio',
  DEVELOPER_STUDIO_CUSTOM_SYNAPSES         : '/developer-studio/custom-synapses',
  DEVELOPER_STUDIO_CUSTOM_ACTIONS          : '/developer-studio/custom-actions',
  DEVELOPER_STUDIO_CUSTOM_SYNAPSE_ITEM     : '/developer-studio/custom-synapses/{synapseType}/{synapseId}',
  DEVELOPER_STUDIO_CUSTOM_SYNAPSE_ENTITIES : '/developer-studio/custom-synapses/http/{synapseId}/entities/{version}',
  DEVELOPER_STUDIO_CUSTOM_SYNAPSE_ENTITY   : '/developer-studio/custom-synapses/http/{synapseId}/entities/{version}/{entityId}',
};

// Known query parameters for the login page
export const REDIRECT_TO = 'redirectTo';
export const ERROR_MESSAGE = 'errorMessage';

// syncari url
export const SYNCARI_BASE_URL = 'https://syncari.com';

export default RouteConstants;
